import React from "react";
import JapaneseColorApp from "./JapaneseColorApp";

function App() {
  return (
    <div className="App">
      <JapaneseColorApp />
    </div>
  );
}

export default App;
